import {Component} from '@angular/core';
import {DialogRef, DialogService} from '@progress/kendo-angular-dialog';
import {KendoPopupUtils} from '../../lib/KendoPopupUtils';
import {ModalKendo} from '../../lib/ModalKendo';
import {EstoqueService} from '../../services/estoque.service';

@Component({
  selector: 'app-cad-vinculo-fornecimento-item',
  templateUrl: './cad-vinculo-fornecimento-item.component.html',
  styleUrls: ['./cad-vinculo-fornecimento-item.component.scss']
})
export class CadVinculoFornecimentoItemComponent extends ModalKendo {
  apresentacao: any;
  insumo: any;
  insumoId: number;
  resultado: any;
  termo = '';
  codigoFornecedor = '';
  produtos: any[] = [];
  produtosFiltrados: any[] = [];
  produtoSelecionado: any;
  categorias: string[] = [];
  unidades: string[] = [];
  categoriaFiltro = '';
  unidadeFiltro = '';
  etapa = 1;
  carregando = false;
  buscandoCodigo = false;
  confirmando = false;
  removendo = false;
  alterado = false;
  mensagemErro: string;
  mensagemSucesso: string;

  constructor(private estoqueService: EstoqueService) {
    super();
  }

  static abraModal(
    dialogService: DialogService,
    apresentacao: any,
    insumo: any
  ): DialogRef {
    const windowRef: DialogRef = dialogService.open({
      content: CadVinculoFornecimentoItemComponent,
      minWidth: 250,
      width: Math.min(1280, Math.max(250, window.innerWidth - 30)),
      cssClass: 'bsModal modal-vinculo-produto-fabrica',
      maxHeight: window.innerHeight - 40
    });
    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);
    windowRef.content.instance.inicialize(apresentacao, insumo);
    return windowRef;
  }

  inicialize(apresentacao: any, insumo: any): void {
    this.apresentacao = apresentacao;
    this.insumo = insumo || apresentacao && apresentacao.insumo || {};
    this.insumoId = Number(this.insumo && this.insumo.id);
    this.codigoFornecedor = apresentacao && apresentacao.codigoFornecedor || '';
    this.carregueCatalogo();
  }

  busquePorCodigo(): void {
    if(this.buscandoCodigo || this.carregando || !this.codigoFornecedorValido())
      return;
    this.buscandoCodigo = true;
    this.limpeMensagens();
    const codigo = this.normalize(this.codigoFornecedor);
    const encontrados = this.produtos.filter(produto =>
      this.normalize(produto.codigo) === codigo
    );
    this.buscandoCodigo = false;
    if(!codigo) {
      this.mensagemErro = 'Informe o código do produto na fábrica.';
      return;
    }
    if(encontrados.length !== 1) {
      this.mensagemErro = encontrados.length
        ? `O código ${codigo} corresponde a mais de um produto elegível.`
        : `Nenhum produto elegível foi encontrado com o código ${codigo}.`;
      return;
    }
    this.selecioneProduto(encontrados[0]);
  }

  codigoFornecedorValido(): boolean {
    return String(this.codigoFornecedor || '').trim().length <= 255;
  }

  pesquise(): void {
    this.apliqueFiltros();
  }

  selecioneProduto(produto: any): void {
    if(!produto || !produto.id || this.confirmando)
      return;
    this.limpeMensagens();
    this.produtoSelecionado = produto;
    this.etapa = 2;
  }

  confirmeVinculo(): void {
    if(!this.produtoSelecionado || this.confirmando)
      return;
    this.confirmando = true;
    this.limpeMensagens();
    this.salveCodigoSelecionado()
      .then(() => this.estoqueService.listeProdutosSugeridosFornecimento(
        Number(this.apresentacao.id),
        ''
      ))
      .then((resultado: any) => {
        this.resultado = resultado;
        const atual = this.produtoAtual();
        if(atual && Number(atual.id) === Number(this.produtoSelecionado.id))
          return null;
        const vinculo = resultado && resultado.vinculo;
        return vinculo && vinculo.id
          ? this.estoqueService.atualizeVinculoFornecimentoItem(Number(vinculo.id), {
              produtoFabrica: {id: this.produtoSelecionado.id},
              ativo: true
            })
          : this.estoqueService.crieVinculoFornecimentoItem({
              apresentacaoInsumo: {id: this.apresentacao.id},
              produtoFabrica: {id: this.produtoSelecionado.id},
              ativo: true
            });
      }).then(() => {
        this.confirmando = false;
        this.alterado = true;
        this.fecheModal({alterado: true});
      }).catch((erro: any) => {
        this.confirmando = false;
        this.mensagemErro = erro;
      });
  }

  remova(): void {
    const vinculo = this.resultado && this.resultado.vinculo;
    if(this.removendo || !vinculo || !vinculo.id)
      return;
    this.removendo = true;
    this.limpeMensagens();
    this.estoqueService.atualizeVinculoFornecimentoItem(Number(vinculo.id), {
      ativo: false
    }).then(() => {
      this.alterado = true;
      this.removendo = false;
      this.mensagemSucesso = 'Vínculo removido com sucesso.';
      this.produtoSelecionado = null;
      this.etapa = 1;
      this.carregueCatalogo();
    }).catch((erro: any) => {
      this.removendo = false;
      this.mensagemErro = erro;
    });
  }

  feche(): void {
    if(this.confirmando || this.removendo)
      return;
    this.fecheModal({alterado: this.alterado});
  }

  rotuloStatus(): string {
    const status = this.resultado && this.resultado.status;
    return {
      VINCULADO: 'Vinculado',
      PENDENTE: 'Pendente',
      AMBIGUO: 'Ambíguo',
      INCOMPATIVEL: 'Incompatível'
    }[status] || 'Pendente';
  }

  classeStatus(): string {
    const status = this.resultado && this.resultado.status;
    return {
      VINCULADO: 'badge-success',
      PENDENTE: 'badge-warning',
      AMBIGUO: 'badge-info',
      INCOMPATIVEL: 'badge-danger'
    }[status] || 'badge-warning';
  }

  produtoAtual(): any {
    return this.resultado && this.resultado.vinculo
      ? this.resultado.vinculo.produto
      : null;
  }

  ehProdutoAtual(produto: any): boolean {
    const atual = this.produtoAtual();
    return !!atual && Number(atual.id) === Number(produto && produto.id);
  }

  ehProdutoSelecionado(produto: any): boolean {
    return !!this.produtoSelecionado &&
      Number(this.produtoSelecionado.id) === Number(produto && produto.id);
  }

  categoriaDoProduto(produto: any): string {
    return produto && produto.categoria && produto.categoria.nome || 'Sem categoria';
  }

  unidadeDoProduto(produto: any): string {
    return produto && produto.insumoOrigem && produto.insumoOrigem.unidadeBase
      ? produto.insumoOrigem.unidadeBase.sigla
      : '-';
  }

  conversaoDaUnidade(): string {
    const unidade = this.insumo && this.insumo.unidadeMedida;
    const fator = this.apresentacao && this.apresentacao.apresentacaoCompra &&
      this.apresentacao.apresentacaoCompra.fatorConversao;
    return fator != null
      ? `1 → ${Number(fator).toLocaleString('pt-BR')} ${unidade && unidade.sigla || ''}`.trim()
      : '-';
  }

  estoqueDisponivel(produto: any): number {
    return Number(produto && produto.insumoOrigem && produto.insumoOrigem.estoque &&
      produto.insumoOrigem.estoque.quantidadeDisponivel || 0);
  }

  semFabrica(): boolean {
    return String(this.resultado && this.resultado.motivo || '')
      .toLocaleLowerCase().includes('não possui uma fábrica');
  }

  private carregueCatalogo(): void {
    this.carregando = true;
    this.mensagemErro = null;
    this.estoqueService.listeProdutosSugeridosFornecimento(
      Number(this.apresentacao.id),
      ''
    ).then((resultado: any) => {
      this.resultado = resultado;
      this.produtos = resultado.produtos || [];
      this.monteFiltros();
      this.apliqueFiltros();
      const atual = this.produtoAtual();
      if(atual && !this.produtoSelecionado)
        this.produtoSelecionado = this.produtos.find(produto =>
          Number(produto.id) === Number(atual.id)
        ) || atual;
      this.carregando = false;
    }).catch((erro: any) => {
      this.mensagemErro = erro;
      this.carregando = false;
    });
  }

  private apliqueFiltros(): void {
    const termo = this.normalize(this.termo);
    this.produtosFiltrados = this.produtos.filter(produto => {
      const texto = [
        produto.nome,
        produto.codigo,
        produto.descricao,
        produto.insumoOrigem && produto.insumoOrigem.nome,
        produto.insumoOrigem && produto.insumoOrigem.codigo,
        this.categoriaDoProduto(produto)
      ].map(valor => this.normalize(valor)).join(' ');
      return (!termo || texto.includes(termo)) &&
        (!this.categoriaFiltro || this.categoriaDoProduto(produto) === this.categoriaFiltro) &&
        (!this.unidadeFiltro || this.unidadeDoProduto(produto) === this.unidadeFiltro);
    });
  }

  private monteFiltros(): void {
    this.categorias = Array.from(new Set(this.produtos.map(produto =>
      this.categoriaDoProduto(produto)
    ))).sort();
    this.unidades = Array.from(new Set(this.produtos.map(produto =>
      this.unidadeDoProduto(produto)
    ))).sort();
  }

  private salveCodigoSelecionado(): Promise<any> {
    const codigoDigitado = this.normalize(this.codigoFornecedor);
    const codigoProduto = this.normalize(this.produtoSelecionado && this.produtoSelecionado.codigo);
    const codigoAtual = this.normalize(this.apresentacao && this.apresentacao.codigoFornecedor);
    if(!codigoDigitado || codigoDigitado !== codigoProduto || codigoDigitado === codigoAtual)
      return Promise.resolve(null);
    return this.estoqueService.salveApresentacaoCompra(this.insumoId, {
      id: this.apresentacao.id,
      codigoFornecedor: this.codigoFornecedor,
      ativa: !!this.apresentacao.ativa,
      padrao: !!this.apresentacao.padrao
    }).then((salva: any) => {
      this.apresentacao = Object.assign({}, this.apresentacao, salva);
      this.codigoFornecedor = salva.codigoFornecedor || '';
      return salva;
    });
  }

  private normalize(valor: any): string {
    return String(valor || '').trim().toLocaleUpperCase();
  }

  private limpeMensagens(): void {
    this.mensagemErro = null;
    this.mensagemSucesso = null;
  }
}
